
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","fill":"#F7BC00"}}),_c('path',{attrs:{"d":"M15.227 10.553h-1.329a1.653 1.653 0 00-.209-.579 1.557 1.557 0 00-.898-.7 2.023 2.023 0 00-.622-.091c-.395 0-.746.099-1.051.298-.305.196-.545.485-.717.866-.173.38-.26.842-.26 1.389 0 .556.087 1.025.26 1.406.175.379.414.665.717.86.305.191.655.287 1.048.287.217 0 .421-.028.61-.085.192-.06.364-.146.515-.26a1.58 1.58 0 00.607-.987l1.329.007a2.86 2.86 0 01-.324.973 2.87 2.87 0 01-.642.803c-.265.23-.576.41-.93.54a3.47 3.47 0 01-1.183.192c-.64 0-1.21-.148-1.712-.444a3.097 3.097 0 01-1.186-1.282c-.289-.559-.433-1.229-.433-2.01 0-.784.145-1.454.437-2.01a3.12 3.12 0 011.19-1.282A3.292 3.292 0 0112.147 8c.405 0 .781.057 1.13.17.347.114.657.281.93.501.272.218.495.485.67.803.178.315.294.674.349 1.08z","fill":"#000"}})])
          )
        }
      }
    